import React from "react"
import { Outlet } from "react-router-dom"
import DefaultErrorBoundary from "modules/errors/DefaultErrorBoundary"
import FirstLoading from "modules/loader-watchers/FirstLoading"
import CustomPagination from "components/common/CustomPagination"
import { useTranslation } from "react-i18next"
import CrewMembersTable, { dataSource as crewDataSource } from "./crewMembersTable"
import CrewFilters from "./components/CrewFilters"
import FilterChips from "../components/FilterChips"
import { useCrewFilters } from "./hooks/useCrewFilters"
import { useDatePicker } from "./hooks/useDatePicker"

export default function CrewMembersPage() {
  const { t } = useTranslation()

  // Custom hooks for filters and date picker
  const {
    search,
    selectedRoles,
    selectedStatuses,
    currentPage,
    pageSize,
    roleOptions,
    statusOptions,
    expandedSelectedRoles,
    expandedSelectedStatuses,
    filteredData,
    paginatedData,
    setSearch,
    setSelectedRoles,
    setSelectedStatuses,
    handleRemoveRole,
    handleRemoveStatus,
    handleSortChange,
    setCurrentPage,
    setPageSize
  } = useCrewFilters(crewDataSource, t)

  const datePicker = useDatePicker()

  return (
    <div className="vstack flex-fill z-0 mt-l" id="clients">
      <FirstLoading>
        <div className="flex-fill">
          <CrewFilters
            search={search}
            onSearchChange={setSearch}
            selectedRoles={selectedRoles}
            onRoleChange={setSelectedRoles}
            roleOptions={roleOptions}
            selectedStatuses={selectedStatuses}
            onStatusChange={setSelectedStatuses}
            statusOptions={statusOptions}
            datePicker={datePicker}
          />
          {expandedSelectedRoles.length > 0 && (
            <FilterChips selectedItems={expandedSelectedRoles} options={roleOptions} onRemove={handleRemoveRole} />
          )}
          {expandedSelectedStatuses.length > 0 && (
            <FilterChips selectedItems={expandedSelectedStatuses} options={statusOptions} onRemove={handleRemoveStatus} />
          )}
          <CrewMembersTable data={paginatedData} onChange={handleSortChange} />
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 24 }}>
            <CustomPagination
              metadata={{
                page: currentPage,
                total_pages: Math.ceil(filteredData.length / pageSize),
                next_page: currentPage < Math.ceil(filteredData.length / pageSize) ? currentPage + 1 : null,
                prev_page: currentPage > 1 ? currentPage - 1 : null
              }}
              pageSize={pageSize}
              total={filteredData.length}
              onPageChange={(page) => setCurrentPage(page)}
              onPageSizeChange={(size) => {
                setPageSize(size)
                setCurrentPage(1)
              }}
              pageSizeOptions={[5, 10, 20, 50]}
            />
          </div>
        </div>
        <DefaultErrorBoundary>
          <Outlet />
        </DefaultErrorBoundary>
      </FirstLoading>
    </div>
  )
}
